// FLAGS: none
// Group-title cell carrying the expand/collapse control for the check-in tables.
import { FC } from "react";

interface CustomTitleCellProps {
  text: string;
  emptyCell: boolean;
  open?: boolean;
  setOpen?: (open: boolean) => void;
  hideExpandableButton?: boolean;
  hideTitle?: boolean;
}

const CustomTitleCell: FC<CustomTitleCellProps> = ({
  text,
  emptyCell,
  open,
  setOpen,
  hideExpandableButton,
  hideTitle,
}: CustomTitleCellProps) => {
  return (
    <>
      {hideTitle && <td className="py-6" />}
      {emptyCell && open ? <td className="py-6" /> : null}
      {!emptyCell && !hideTitle && (
        <td
          className="flex items-center"
          onClick={(event) => {
            event.stopPropagation();
            setOpen?.(!open);
          }}
        >
          <span className="py-6 text-green-500 font-semibold cursor-pointer underline">
            {text}
          </span>
          {hideExpandableButton && (
            <button
              type="button"
              aria-label="expand row"
              className="p-1 text-green-500 font-semibold bg-transparent border-0 cursor-pointer"
            >
              {open ? (
                <span className="material-icons-outlined text-green-500">
                  {" "}
                  keyboard_arrow_up
                </span>
              ) : (
                <span className="material-icons-outlined text-green-500">
                  {" "}
                  keyboard_arrow_down
                </span>
              )}
            </button>
          )}
        </td>
      )}
    </>
  );
};

export default CustomTitleCell;
